import {Component, Input, OnInit} from '@angular/core';
import {BranchMeasurement} from "../../CardStruct";
import {IconDefinition} from "@fortawesome/fontawesome-common-types";
import {faMoon, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";

@Component({
  selector: 'app-branch-fan',
  templateUrl: './branch-fan.component.html',
  styleUrls: ['./branch-fan.component.css']
})
export class BranchFanComponent implements OnInit {
  @Input() mVariable: BranchMeasurement | undefined;
  icon: IconDefinition = faMoon;

  mValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  ngOnInit(): void {
    if(this.mVariable)
      this.mValue = this.variableDB.AddValueByReference(this.mVariable.variable.id);
  }

  GetValue(): number {
    if (this.mValue.IsInvalid())
      return 0;
    return this.mValue.val;
  }
}
